export const NavigateErrorActionTypes = {
	API_RESPONSE_SUCCESS: '@@navigate-error/API_RESPONSE_SUCCESS',
	API_RESPONSE_ERROR: '@@navigate-error/API_RESPONSE_ERROR',
	RESET_ALL_ERRORS: '@@reset-all-errors/RESET_ALL_ERRORS',
}